<div class="flex flex-row flex-wrap items-center gap-3 my-5 px-8">
    @if (showPlay()) {
        <p-button [label]="playLabel()" icon="pi pi-play" styleClass="details-btn details-btn-primary"
            (onClick)="play.emit()" data-testid="details_play" />
    }

    @if (canRecord()) {
        <p-button styleClass="details-btn details-btn-secondary"
            [label]="(recorded() ? 'epg.buttons.unrecord' : 'epg.buttons.record') | transloco"
            [icon]="recorded() ? 'pi pi-stop-circle' : 'pi pi-circle-fill'" (onClick)="record.emit()" />

        <!-- <p-button styleClass="details-btn details-btn-secondary" icon="pi pi-bell"
            [label]="'epg.buttons.reminder' | transloco" (onClick)="remind.emit()" /> -->
    }

    @if (canWatchLater()) {
        <p-button [rounded]="true" styleClass="details-btn details-btn-secondary"
            [icon]="watchLater() ? 'pi pi-heart-fill' : 'pi pi-heart'"
            [attr.data-testid]="watchLater() ? 'details_favorite-remove' : 'details_favorite-add'"
            (onClick)="toggleWatchLater.emit()" />
    }

    <p-button styleClass="details-btn details-btn-secondary" icon="pi pi-share-alt"
        [label]="'vod.buttons.share' | transloco" (onClick)="shareMenu.toggle($event)" />
    <p-menu #shareMenu [model]="shareItems" [popup]="true" appendTo="body" />
</div>
